import { render, staticRenderFns } from "./case-division-import-list.vue?vue&type=template&id=498c98aa&scoped=true"
import script from "./case-division-import-list.vue?vue&type=script&lang=ts"
export * from "./case-division-import-list.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "498c98aa",
  null
  
)

export default component.exports